import React, { useState, useEffect } from 'react';
import { Row, Form, Button, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import Icon from 'components/Icons/Icon';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import { darkModeSelectStyles } from "components/Common/CustomStyles/darkModeSelectStyles";
import '../../AddSingleSite/AddToEnterpriseElement.scss';
import {
  selectEnterpriseFields,
  selectEnterpriseGroups,
} from "services/redux/selectors/serviceDesk/addSite";
import { 
  loadEnterpriseFieldsStart,
  loadEnterpriseFieldsReset,
  loadEnterpriseGroupsStart,
  loadEnterpriseGroupsReset,
 } from "services/redux/actions/serviceDesk";
import Loading from "components/Loading";

import Alert from 'components/Common/Alert';

import GroupsSelect from './GroupsSelect';

function AddToEnterpriseSiteEditor({
  // props
  accordionStyle,
  enterprise,
  setEnterprise,
  name,
  setName,
  custom_site_ref,
  setCustomSiteRef,
  billingStatus,
  setBillingStatus,
  enterprise_groups,
  setEnterpriseGroups,
  enterpriseCustomFieldsData,
  setEnterpriseCustomFieldsData,
  formBillingStatus,
  invalidEnterprise, 
  setInvalidEnterprise, 
  formEnterprises, 
  addToEnterprise,
  setAddToEnterprise,
  mapCustomFields,
  formEnterpriseGroups,
  setFormEnterpriseGroups,
  initialiseFormDataTrigger,
  tooltip = false,
  tooltipPlacement = "left",
  tooltipText = "Add site to an enterprise? (optional)",
  disabledProp = false,
  changeDetected,
  disabled,
  setDisabled,
  enterpriseAssociations,
  setInitialiseFormDataTrigger,
  loadingEnterpriseList,
  setShowEditButton,
  setAlternateEditStyle,
  alternateEditStyle,
  editMode,
  setEditMode,
  associations,
  setDisableEditButton,
  editAvailable,
 }) {

  const dispatch = useDispatch();
  // redux selectors ------
  const darkMode = useSelector((state) => state.app.darkMode)
  const { getEnterpriseFieldsData } = useSelector(selectEnterpriseFields);
  const { getEnterpriseGroupsData } = useSelector(selectEnterpriseGroups);
  const loadingGroups = useSelector(state => state.serviceDesk.enterpriseGroups.loading);
  // -------------------

  const [initInvalidComponent] = useState({
    enterprise_name: {null: true},
    enterprises: {null: true},
    billing_status: {null: true},
  });
  const [invalidEntComponent, setInvalidEntComponent] = useState(initInvalidComponent);
  const [enterpriseCustomFields, setEnterpriseCustomFields] = useState({});
  const [showCustomFields, setShowCustomFields] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showFeedback, setShowFeedback] = useState(null);
  const [feedbackCondition, setFeedbackCondition] = useState(null);
  const [loadingUI, setLoadingUI] = useState(null);
  const [invalidOptions, setInvalidOptions] = useState({ form: false });

  useEffect(() => {
    if (editAvailable) {
      setShowEditButton(true);

      return () => {
        setShowEditButton(false);
      }
    }
  }, [])

  useEffect(() => {
    if (loadingUI === false && Array.isArray(formEnterprises) ) {
      setInvalidOptions({
        form: Array.isArray(formEnterprises) && formEnterprises.length <= 0 ? 
          enterpriseAssociations.length > 0 ? 
            'There are no more enterprises left available to associate with this site.' 
          : 
            'There are no enterprises available to associate with this site.' 
        : false,
      })
    } else {
      setInvalidOptions({ form: false })
    }
  }, [enterpriseAssociations, formEnterprises, loadingUI])

  // sets whether processing is still taking place before rendering UI ------------------------------------>
  useEffect(() => {
    setLoadingUI(formEnterprises === null || loadingEnterpriseList);
  }, [formEnterprises, loadingEnterpriseList])
  // -------------------------------------------------------------------------------------------------------|

  useEffect(() => {
    if (invalidOptions.form) {
      setFeedbackCondition(invalidOptions.form);
    } else {
      setFeedbackCondition(false);
    }
  }, [invalidOptions.form])

  useEffect(() => {
    setDisabled(loadingUI !== false || feedbackCondition || disabledProp || (editMode && !alternateEditStyle));
  }, [formEnterprises, disabledProp, editMode, alternateEditStyle, enterpriseAssociations, feedbackCondition, loadingUI])
  
  useEffect(() => {
    if (disabled || (editMode && !alternateEditStyle) || !editMode) {
      setAddToEnterprise(false);
    }
  }, [disabled, editMode])

  useEffect(() => {
    if (editAvailable) {
      setDisableEditButton(associations?.length <= 0 || addToEnterprise);
      
      if (addToEnterprise) {
        // setEditSubmissionType(false);
        setAlternateEditStyle(true);
        editAvailable &&  setEditMode(true);
        setDisableEditButton(true);
      } else {
        // editAvailable &&  setEditMode(!editMode)
      }
    }
  }, [addToEnterprise, associations]);

  const toggleAccordion = () => {
    if (changeDetected && addToEnterprise) {
      Alert({
        text: `Exit edit mode? Any unsaved changes will be lost. `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Exit",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.value) {
          setAddToEnterprise(!addToEnterprise);
          setInitialiseFormDataTrigger(true);
          editAvailable &&  setEditMode(false);
        } else {
          return
        }
      })
    } else {
      setAddToEnterprise(!addToEnterprise);
      editAvailable &&  setEditMode(false);
    }
  }

  const handleMouseEnter = () => {
    setIsHovered(false);
  }
  
  const handleMouseLeave = () => {
    setIsHovered(true);
  }

  useEffect(() => {
    // addToEnterprise && Object.values(invalidEntComponent).some(value => value.null) ? setInvalidEnterprise(true) : setInvalidEnterprise(false);
    addToEnterprise && setInvalidEnterprise(Object.values(invalidEntComponent).some(value => value.null));
    // enterpriseAssociations.length > 0 && setInvalidEnterprise(enterpriseAssociations[0].enterprise.id !== value && handleCheckEntSiteExists)
  }, [invalidEnterprise, 
    invalidEntComponent, 
    addToEnterprise, 
    setInvalidEnterprise,
    name,
    enterprise,
    custom_site_ref,
    billingStatus,
    enterprise_groups,
    enterpriseCustomFieldsData,
  ])

  useEffect(() => {
    if (initialiseFormDataTrigger) {
      setInvalidEntComponent(initInvalidComponent)
    }
  }, [initialiseFormDataTrigger, initInvalidComponent, setInvalidEntComponent])

  const handleNullChange = (name, value) => {
    setInvalidEntComponent((prevState) => ({
      ...prevState,
      [name]: { null: value ? false : true},
    }));
  };

  useEffect(() => {
    if (enterprise) {
      dispatch(loadEnterpriseGroupsStart({ enterprise }))
    } else {
      setFormEnterpriseGroups([])
      setEnterpriseGroups([])
    }
  }, [enterprise, setEnterpriseGroups, setFormEnterpriseGroups, dispatch])

  useEffect(() => {
    if (addToEnterprise && enterprise) {
      dispatch(loadEnterpriseFieldsStart({ enterprise }))
    } else {
      setEnterpriseCustomFields({});
      setFormEnterpriseGroups([]);
    }

    if (!addToEnterprise) {
      setBillingStatus("");
      setEnterpriseCustomFields({});
      setEnterprise(null);
      setEnterpriseGroups([]);
      setFormEnterpriseGroups([]);
      dispatch(loadEnterpriseFieldsReset());
      dispatch(loadEnterpriseGroupsReset());
    }
  }, [addToEnterprise, enterprise, setEnterprise, setEnterpriseGroups, billingStatus, setFormEnterpriseGroups, dispatch, setBillingStatus])

  useEffect(() => {
    getEnterpriseFieldsData ? setEnterpriseCustomFields(getEnterpriseFieldsData) : setEnterpriseCustomFields({});
  }, [getEnterpriseFieldsData])
  
  useEffect(() => {
    if (enterprise) {
      getEnterpriseGroupsData && setFormEnterpriseGroups(Object.entries(getEnterpriseGroupsData?.['groups']).map(([key, value]) => {
        return {label: value, value: key}
      }));
    }
  }, [getEnterpriseGroupsData, enterprise, setFormEnterpriseGroups])

  useEffect(() => {
    enterpriseCustomFields && enterprise && Object.entries(enterpriseCustomFields).length > 0 ? setShowCustomFields(true) : setShowCustomFields(false);
  }, [enterpriseCustomFields, enterprise])

  return (
    <>
      <div
        className={`custom-card add-to-enterprise-container ${accordionStyle && (!addToEnterprise || !isHovered ? "enterprise-hover" : "")} ${darkMode ? "darkMode" : ""} ${disabled ? "disabled" : ""}`}
        id='enterprise-card'
        data-intercom-target={"add-to-enterprise-container"}
        onClick={() => {
          if (!addToEnterprise) {
            toggleAccordion()
          }
        }}
      >
      {!accordionStyle && <div className='enterprise-card-header mb-3'>Add Site to Enterprise</div>}
      {accordionStyle &&
        <>
          {addToEnterprise ?
            <div
              className={`d-flex justify-content-between enterprise-card-header ${addToEnterprise ? "enterprise-card-header-after" : "enterprise-card-header"}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                if (addToEnterprise) {
                  toggleAccordion()
                }
              }}
            >
              <div>Add Site to Enterprise</div>
              <Button
                onClick={toggleAccordion}
                // className={`${!accordionStyle && 'd-none'}`}
              >
                <Icon className={`fas ${addToEnterprise ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
              </Button>
            </div>
          :
            <div
              className={`d-flex justify-content-between enterprise-card-header ${addToEnterprise ? "enterprise-card-header-after" : "enterprise-card-header"}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                if (addToEnterprise) {
                  toggleAccordion()
                }
              }}
            >
              <div>Add Site to Enterprise</div>
              {loadingUI !== false ?
                <div className='d-flex justify-content-center align-items-center accordion-button-height'>
                  <Loading />
                </div>
              :
                disabled && tooltip ?
                  <Tooltip
                    description={tooltipText}
                    placement={tooltipPlacement}
                  >
                    <Button
                      data-intercom-target={"add-to-enterprise-toggle"}
                      onClick={toggleAccordion}
                      className={`${!accordionStyle && 'd-none'}`}
                    >
                      <Icon className={`fas ${addToEnterprise ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
                    </Button>
                  </Tooltip>
                :
                  <Button
                    data-intercom-target={"add-to-enterprise-toggle"}
                    onClick={toggleAccordion}
                    className={`${!accordionStyle && 'd-none'} accordion-button-height`}
                  >
                    <Icon className={`fas ${addToEnterprise ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
                  </Button>
              }
            </div>
          }
        </>
      }
          {addToEnterprise &&
            <Form.Group id="form-inputs">
              <Row>
                <Col
                  controlid="company_name_id"
                  className="col-12 col-sm-6 mb-3"
                >
                  <Form.Label>Enterprise Site Name *</Form.Label>
                  <Form.Control
                    data-intercom-target={"add-to-enterprise-site-name"}
                    type="text"
                    name="enterprise_site_name"
                    className="form-input"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value)
                      handleNullChange("enterprise_name", e.target.value)
                    }}
                  />
                </Col>
                <Col 
                  className="col-12 col-sm-6 mb-3"
                  controlid="site_type">
                  <Form.Label>Custom Site Ref</Form.Label>
                  <Form.Control
                    data-intercom-target={"add-to-enterprise-custom-site-ref"}
                    type="text"
                    name="custom_site_ref"
                    className="form-input"
                    value={custom_site_ref}
                    onChange={(e) => {setCustomSiteRef(e.target.value)}}
                  />
                </Col>
              </Row>
              <Row>
                <Form.Group 
                  className="col-12 col-sm-6 mb-3 col"
                  controlId="site_type">
                  <div>
                    <Form.Label>Enterprise *</Form.Label>
                  </div>
                  <Select
                    data-intercom-target={"add-to-enterprise-enterprise-select"}
                    name="enterprises"
                    options={Array.isArray(formEnterprises) && formEnterprises.sort((a, b) => a.label.localeCompare(b.label))}
                    required={addToEnterprise}
                    value={
                      enterprise 
                      ? Array.isArray(formEnterprises) && formEnterprises.find(option => option.value === enterprise)
                      : null
                    }
                    isClearable
                    maxMenuHeight={400}
                    onChange={(e) => {
                      setEnterprise(e ? e.value : null)
                      handleNullChange("enterprises", e ? e.value : null)
                    }}
                    styles={darkMode ? darkModeSelectStyles : ""}
                  />
                </Form.Group>
                <Form.Group
                  className="col-12 col-sm-6 mb-3 col"
                  controlId="site_type">
                  <Form.Label>Billing Status *</Form.Label>
                  <Select
                    data-intercom-target={"add-to-enterprise-billing-status-select"}
                    name="billing_status"
                    options={formBillingStatus.sort((a, b) => a.label.localeCompare(b.label))}
                    value={
                      billingStatus 
                      ?
                        formBillingStatus.find(option => option.value === billingStatus) 
                      : ""
                    }
                    isClearable
                    maxMenuHeight={400}
                    onChange={(e) => {
                      setBillingStatus(e ? e.value : "")
                      handleNullChange("billing_status", e ? e.value : null)
                    }}
                    styles={darkMode ? darkModeSelectStyles : ""}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Col className="col-12 col-sm-6 mb-3">
                  <span className="d-flex -flex-row justify-content-between align-items-center">
                    <Form.Label>Group</Form.Label>
                    {loadingGroups && <Loading />}
                  </span>
                  {enterprise && !loadingGroups ?
                    <GroupsSelect
                      groups={enterprise_groups}
                      groupsFormData={formEnterpriseGroups}
                      groupValues={enterprise_groups}
                      enterpriseId={enterprise}
                      setGroupValues={setEnterpriseGroups}
                      setGroupsFormData={setFormEnterpriseGroups}
                      editing={false}
                      editMode={editMode}
                      alternateEditStyle={true}
                      hidden={!editMode}
                    />
                  :
                    <Select
                      data-intercom-target={"add-to-enterprise-group-select"}
                      classNamePrefix="edit-group-modal-parent-select"
                      name="enterprise_groups_no_enterprise"
                      className="no-click"
                      value={""}
                    />
                  }
                </Col>
              </Row>
              
              {/* Custom Fields Header */}
              <Form.Text className="custom-card-header">Enterprise Fields</Form.Text>

              {!showCustomFields && <Form.Text className="font-italic">This enterprise has no custom fields</Form.Text>}

              {showCustomFields &&
                mapCustomFields(enterpriseCustomFields, setEnterpriseCustomFieldsData)
              }

            </Form.Group>
          }
      </div>
      {<Form.Control.Feedback type="warning" className="trigger-feedback-invalid col p-0">
        <div className={`feedback-container-${feedbackCondition ? "after" : "before"}`}>
            <div className="d-flex align-items-center flex-wrap justify-content-between">
              <div className="feedback-text-stack col-9">
                {feedbackCondition}
                <div className="mt-1 p-0">Contact the team to learn more.</div>
              </div>
              <Button className="feedback-button col-3" variant="primary" data-intercom-target={"open-chat-button-add-ent-site"}>Open Chat</Button>
            </div>
        </div>
      </Form.Control.Feedback>
      }
    </>
  )
}

export default AddToEnterpriseSiteEditor;